import { __assign, __awaiter, __generator } from "tslib";
import { getThreeDsChallengeDisplaySize, renderIframeAndWaitForPostback, } from '../3d-secure';
import { logTaggedMessage } from '../../reporter';
import { getIframeOriginToBeValidatedForWixDomain, threeDsErrors, } from '../3ds-utils';
import { removeChallengeIframe } from '../iframe-handler';
import { MethodType } from '@wix/ambassador-checkout-view-server/types';
var log = logTaggedMessage({
    module: '3ds',
    sub_moodule: 'redirect-action',
});
export var redirectAction = function (_a) {
    var actionData = _a.data, methodUrl = _a.methodUrl, provider = _a.provider, methodType = _a.methodType;
    return __awaiter(void 0, void 0, void 0, function () {
        var challengeDisplaySize, redirectMethod, success, fail, logData, ret, resultPromise, redirectResult, err, ret, e_1, ret;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    challengeDisplaySize = getThreeDsChallengeDisplaySize();
                    redirectMethod = methodType === MethodType.POST ? 'POST' : 'GET';
                    success = function (redirectResultData) {
                        var dataToServer = __assign(__assign({}, redirectResultData), actionData);
                        return {
                            redirectData: {
                                provider: provider,
                                data: dataToServer,
                                received: {},
                            },
                        };
                    };
                    fail = function (error) {
                        return {
                            redirectData: {
                                provider: provider,
                                data: actionData,
                                notReceived: { error: error },
                            },
                        };
                    };
                    logData = {
                        actionData: actionData,
                        methodUrl: methodUrl,
                        provider: provider,
                        challengeDisplaySize: challengeDisplaySize,
                    };
                    log('3ds: before render 3ds redirect iframe', logData);
                    if (!methodUrl) {
                        ret = fail(threeDsErrors.missingUrl(provider.providerType, 'redirect'));
                        log("3ds: ".concat(provider, " redirect action failed"), __assign(__assign({}, logData), { ret: ret }));
                        return [2 /*return*/, ret];
                    }
                    resultPromise = renderIframeAndWaitForPostback('visible', methodUrl, redirectMethod, actionData, getIframeOriginToBeValidatedForWixDomain());
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, resultPromise];
                case 2:
                    redirectResult = _b.sent();
                    if (!redirectResult) {
                        err = "Redirect Action Error!\n      recived: ".concat(redirectResult);
                        ret = fail(err);
                        log("3ds: ".concat(provider, " redirect action failed"), __assign(__assign({}, logData), { err: err, ret: ret }));
                        return [2 /*return*/, ret];
                    }
                    log('3ds: received redirect success', __assign(__assign({}, logData), { redirectResult: redirectResult }));
                    return [2 /*return*/, success(redirectResult)];
                case 3:
                    e_1 = _b.sent();
                    ret = fail(threeDsErrors.generate3dsError({
                        providerFlow: 'PAYMENTS',
                        step: 'redirect',
                        e: e_1,
                    }));
                    log("3ds: Redirect failed", __assign(__assign({}, logData), { ret: ret, e: e_1 }));
                    return [2 /*return*/, ret];
                case 4:
                    removeChallengeIframe();
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    });
};
//# sourceMappingURL=redirect-action.js.map